import { v4 as uuid } from "uuid";
import type { Person } from "@/services/api";

export const createTempPerson = () => {
  return {
    id: `new-${uuid()}`,
    birthdaySDate: { day: null, month: null, year: null },
    firstName: null,
    middleName: null,
    lastName: null,
    gender: "NOT_DEFINED",
    title: null,
    group: "Other",
    birthday: null,
    additionalInformation: null,
    avatarFile: null,
    addresses: [],
    phones: [],
    anniversaries: [],
    emails: [],
    websites: [],
    socialNetworks: [],
    careers: [],
    competences: [],
    hobbies: [],
    personConnections: [],
    notes: [],
    professionalActivities: [],
    educations: [],
    tags: [],
    lastModifiedDate: "",
  } as Person;
};

export const isTempPerson = (person: Person) => {
  return person.id.startsWith("new-");
};
